import LiferayFetchAPI, {
    REACT_APP_LIFERAY_API
} from "./api";
import Cookies from "js-cookie";

const accessToken = Cookies.get("cognito-access-token");

const getIdList = async (base_url_api) => {
    const response = await LiferayFetchAPI.get(`${base_url_api}ListaIds`, { accessToken });
    return response?.data || [];
}



const getPagos = async (base_url_api, id_client, sociedad, url_ws_empresa) => {
    let json = {
        "ITEM": {
            "cta_cto": id_client,
            "Sociedad": sociedad
        },
        "url": url_ws_empresa
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}pagosRealizados`, { accessToken, body: json });
    return response?.data || [];
}

const getEstaSinLuz = async (base_url_api, id_cta_cto, sociedad, url_ws_empresa) => {
    let json = {
        "ITEM": {
            "cta_cto": id_cta_cto,
            "Sociedad": sociedad
        },
        "url": url_ws_empresa
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}estasSinLuz`, { accessToken, body: json });
    return response?.data || [];
}

const getTipoPresentacion = async (base_url_api) => {
    const response = await LiferayFetchAPI.post(`${base_url_api}tipoPresentaciones`);
    return response?.data || [];
}

const getComuna = async (base_url_api, sociedad) => {
    let json = {
        "empresa": sociedad
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}comunas`, { accessToken, body: json });
    return response?.data || [];
}

const getAllComunas = async (base_url_api) => {
    const response = await LiferayFetchAPI.post(`${base_url_api}all-comunas`);
    return response?.data || [];
}

const getCalles = async (base_url_api, comuna_id) => {
    let json = {
        "comunaId": comuna_id
    }
    const response = await LiferayFetchAPI.post(`${base_url_api}calles-por-comuna`, { accessToken, body: json });
    return response?.data || [];
}

const getClienteDireccion = async (base_url_api, sociedad, bodyClienteDireccion, codigo_ciudad, url_ws_empresa) => {
    let json = {
        "CODIGO_CALLE": bodyClienteDireccion[0],
        "CODIGO_CIUDAD": codigo_ciudad,
        "NUMERO": bodyClienteDireccion[1],
        "NUMERO2": bodyClienteDireccion[2],
        "SOCIEDAD": sociedad,
        "url": url_ws_empresa
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}busquedaClientePorDireccion`, { accessToken, body: json });
    return response?.data || [];
}

const getClienteMedidor = async (base_url_api, sociedad, bodyClienteMedidor, url_ws_empresa) => {
    let json = {
        "NroMedidor": bodyClienteMedidor[0],
        "Sociedad": sociedad,
        "url": url_ws_empresa
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}busquedaClientePorMedidor`, { accessToken, body: json });
    return response?.data || [];
}

const postFormCont = async (base_url_api, TicketTecnico, url_ws_empresa, correo) => {

    let json = {
        "crearTicketTecnicoRequestParam": {
            TicketTecnico
        },
        // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
        "url": url_ws_empresa,
        "webContentCorreoEstasSinLuz": correo
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}registrarContingencia`, { accessToken, body: json });
    return response?.data || [];
}

const getSaldoCross = async (base_url_api, body_sc, sociedad, url_ws_empresa) => {
    let json = {
        "I_CANAL": body_sc[0],
        "I_VKONT": body_sc[1],
        "Sociedad": sociedad,
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}consultarDeudaActualVencida`, { accessToken, body: json });
    return response?.data || [];
}

const getDebtCc = async (base_url_api, body_dcc, url_ws_empresa) => {
    let json = {
        "ITEM": {
            "CANAL": body_dcc[0],
            "CTA_CTO": body_dcc[1]
        },
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}consultarDeudaPorCuentaContrato`, { accessToken, body: json });
    return response?.data || [];
}

const getCouponCc = async (base_url_api, body_ccc, sociedad, url_ws_empresa) => {
    let json = {
        "ITEM": {
            "CTA_CTO": body_ccc[0],
            "Sociedad": sociedad,
            "TIPO_CONSULTA": body_ccc[1]
        },
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}consultarCuponPorCuentaContrato`, { accessToken, body: json });
    return response?.data || [];
}

const getCurrentBalance = async (base_url_api, dataidClient, sociedad, url_ws_empresa, screenName) => {
    let json = {
        "ITEM": {
            "RUT": screenName,
            "SOCIEDAD": sociedad,
            "CUENTAS": {
                "CUENTA_CONTRATO": dataidClient?.idClient
            }
        },
        "numPage": dataidClient?.numPage,
        "quantItems": dataidClient?.quantItems,
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}saldoActual`, { accessToken, body: json });
    return response?.data || [];
}

const getListaClientesAssociados = async (base_url_api, dataidClient, sociedad, url_ws_empresa, screenName) => {
    let json = {
        "ITEM": {
            "RUT": screenName,
            "SOCIEDAD": sociedad,
            "CUENTAS": {
                "CUENTA_CONTRATO": dataidClient?.idClient
            }
        },
        "numPage": dataidClient?.numPage,
        "quantItems": dataidClient?.quantItems,
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}listaClientesAssociados`, { accessToken, body: json });
    return response?.data || [];
}

const getCurrentEstadoServicio = async (base_url_api, idClient, sociedad, url_ws_empresa) => {
    let json = {
        "ITEM": {
            "RUT": "",
            "SOCIEDAD": "",
            "CUENTAS": {
                "CUENTA_CONTRATO": idClient
            }
        },
        "url": url_ws_empresa
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}estadoDelServicio`, { accessToken, body: json });
    return response?.data || [];
}

const getCompensation = async (base_url_api, idClient, sociedad, url_ws_empresa, periodo, signedIn) => {
    let json = {
        "CuentaContrato": idClient,
        "Periodo": periodo,
        "Sociedad": sociedad,
        "signedIn": signedIn,
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.postPDF(`${base_url_api}consultarCartolaCompensacion`,
        {
            accessToken, body: json,
        });
    return response;
}

const getListaCartolaReliquidation = async (base_url_api, url_ws_empresa) => {
    let json = {
        "FECHA_FIN": "",
        "FECHA_INICIO": "",
        "url": url_ws_empresa
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}consultarListaCartolaReliquidacion`, { accessToken, body: json });
    return response?.data || [];
}

const getReliquidation = async (base_url_api, idClient, idRelSelected, textRelSelected, sociedad, url_ws_empresa, signedIn, rel_12_2014) => {
    let json = {
        "VKONT": idClient,
        "BUKRS": sociedad,
        "signedIn": signedIn,
        "url": url_ws_empresa,
        "IDRELIQ": idRelSelected,
        "TEXTEXP": textRelSelected,
        "rel122014": rel_12_2014,
    };

    const response = await LiferayFetchAPI.postPDF(`${base_url_api}consultarCartolaReliquidacion`, { accessToken, body: json });
    return response;
}

const getWebContent = async (base_url_api, nameWebContent) => {

    let json = {
        "contentName": nameWebContent,
        // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`
    };

    const response = await LiferayFetchAPI.postWebContent(`${base_url_api}rendered-content`, { accessToken, body: json });
    return (response?.data.search("Connection reset by peer") > 0 || response?.data.search("Internal Server Error") > 0) ? "" : response.data;
}

const getNetbilling = async (base_url_api, id_cta_cto, sociedad, url_ws_empresa) => {
    let json = {
        "ITEM": {
            "Sociedad": sociedad,
            "cta_cto": id_cta_cto
        },
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}consultarResumenBoleta`, { accessToken, body: json });
    return response?.data || [];
}

const getValidClient = async (base_url_api, body_vc, sociedad, url_ws_empresa,captchaToken) => {
    let json = {
        "Canal": body_vc.canal,
        "CuentaContrato": body_vc.numCli,
        "Sociedad": sociedad,
        "url": url_ws_empresa
      };
    
    const response = await LiferayFetchAPI.post(`${base_url_api}validaCliente`, { accessToken, captchaToken, body: json });
    return response?.data || [];
}

const getSimulacionAgreement = async (base_url_api, body_sdc, sociedad, url_ws_empresa,captchaToken) => {
    let json = {
        "I_DATOS": {
          "CANAL": body_sdc.canal,
          "CLAVE_INTERES": body_sdc.clave,
          "CUENTA_CONTRATO": body_sdc.numCli,
          "NUM_CUOTAS": body_sdc.numCuota,
          "PIE_PAGO": body_sdc.pie
        },
        "I_DOC": {
          "item": body_sdc.docs
        },
        "url": url_ws_empresa
      };
    const response = await LiferayFetchAPI.post(`${base_url_api}simulacionDelConvenio`, { accessToken, captchaToken, body: json });
    return response?.data || [];
}
const simularConvenioPagoEspecial = async (base_url_api, { monto, cuotas }, url_ws_empresa, captchaToken) => {
    const json = {
        "Monto": Number(monto) || 0,
        "Canal": "INTER",
        "Cuotas": String(cuotas),
        "Tasa": "L1",
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(
        `${base_url_api}simularConvenioPagoEspecial`,
        { accessToken, captchaToken, body: json }
    );
    return response?.data || [];
};
const validarConvenioPagoEspecial = async (base_url_api, segmento, cuentaContrato, url_ws_empresa, captchaToken) => {
    const json = {
        "Segmento": segmento,
        "CuentaContrato": cuentaContrato,
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(
        `${base_url_api}validarConvenioPagoEspecial`,
        { accessToken, captchaToken, body: json }
    );
    return response?.data || [];
};

const crearConvenioPagoEspecialNotification = async (base_url_api, { cuotas, claveInteres, pie, cuentaContrato }, url_ws_empresa) => {
    const json = {
        "Cuotas": String(cuotas),
        "ClaveInteres": claveInteres || "L1",
        "Pie": Number(pie),
        "CuentaContrato": String(cuentaContrato),
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(
        `${base_url_api}crearConvenioPagoEspecialNotification`,
        { accessToken, body: json }
    );

    return response?.data ?? {};
};

const consultarPuntosSuministro = async (
    base_url_api,
    { cuentaContrato, sociedad, fechaDesde, fechaHasta, tipoMedidor },
    url_ws_empresa
) => {
    const json = {
        CuentaContrato: String(cuentaContrato || ""),
        Sociedad: String(sociedad || ""),
        FechaDesde: String(fechaDesde || ""),  // formato: "YYYY-MM-DD"
        FechaHasta: String(fechaHasta || ""),  // formato: "YYYY-MM-DD"
        TipoMedidor: String(tipoMedidor || "TODOS"),
        url: url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(
        `${base_url_api}consultarPuntoSuministro`,
        { accessToken, body: json }
    );

    return response;
};

const consultarVariablesPuntoSuministro = async (
    base_url_api,
    {
        mRID,
        startTime,
        endTime,
        ctptRatio = "yes",
        variableCimCodes = [],
    },
    url_ws_empresa
) => {
    const json = {
        mRID: String(mRID || ""),
        StartTime: String(startTime || ""),   // "YYYY-MM-DDTHH:mm:ss+00:00"
        EndTime: String(endTime || ""),       // "YYYY-MM-DDTHH:mm:ss+00:00"
        ctpt_ratio: String(ctptRatio || "yes"),
        variable_cim_codes: variableCimCodes,
        url: url_ws_empresa,
    };

    console.log("[AMI] Payload enviar a consultarVariablesPuntoSuministro:", json);

    const response = await LiferayFetchAPI.post(
        `${base_url_api}consultarVariablesPuntoSuministro`,
        { accessToken, body: json }
    );

    return response;
};

const registrarAmiExportExcelLog = async (
    base_url_api,
    {
        medidor,
        tipoEnergia,
        fechaDesde,
        fechaHasta,
        path,
        empresa,
    }
) => {

    const url = `${base_url_api}ami/export-excel-log`;

    const json = {
        medidor: String(medidor || ""),
        tipoEnergia: String(tipoEnergia || ""),
        fechaDesde: String(fechaDesde || ""),
        fechaHasta: String(fechaHasta || ""),
        path: String(path || ""),
        empresa: String(empresa || ""),
    };

    console.log("[AMI][ExportExcelLog] Enviando payload:", json);
    console.log("[AMI][ExportExcelLog] URL:", url);

    const response = await LiferayFetchAPI.post(url, {
        accessToken,
        body: json
    });

    console.log("[AMI][ExportExcelLog] Respuesta:", response);

    return response;
};

const getHistoryConsu = async (base_url_api, id_cta_cto, url_ws_empresa) => {
    let json = {
        "CTA_CTO": id_cta_cto,
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}consultarConsumoHistoricoPorCtaCto`, { accessToken, body: json });
    return response?.data || [];
}

const getResponseDoc = async (base_url_api, id_cta_cto, url_ws_empresa, codigo_empresa, nDoc) => {
    let json = {
        "Doc_Impresion": nDoc,
        "Folio": id_cta_cto,
        "Sociedad": codigo_empresa,
        "Tipo_DTE": "39",
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}consultarBoletaFactura`, { accessToken, body: json });
    return response?.data || [];
}

const createTicketReclamo = async (base_url_api, url_ws_empresa, jsonForms, signedIn, edelmagCorreo) => {
    let json = {
        "TicketTecnico": jsonForms,
        "url": url_ws_empresa,
        "signedIn": signedIn,
        // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
        "edelmagCorreo": edelmagCorreo
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}reclamoEmergenciaElectrica`, { accessToken, body: json });
    return response?.data || [];
}

const createTicketReclamoComercialOrSolicitud = async (base_url_api, json, jsonDoc) => {
    const formData  = new FormData();

    for (const documentName in jsonDoc) {
        if (jsonDoc.hasOwnProperty(documentName)) {
            const documentFile = jsonDoc[documentName]?.[0];
            if (documentFile) {
                formData.append(documentName, documentFile);
            }
        }
    }
    const response = await LiferayFetchAPI.postDocJson(`${base_url_api}addReclamoComercialOrSolicitud`, { accessToken, body: json , auxFormData: formData });
    return response?.data || [];
}

const consultarEstadoServicio = async (base_url_api, id_client, url_ws_empresa) => {
    let json = {
        "NroCliente": id_client,
        "url": url_ws_empresa,

    };
    const response = await LiferayFetchAPI.post(`${base_url_api}consultarEstadoServicio`, { accessToken, body: json });
    return response?.data || [];
}

const createAgreement = async (base_url_api, body_ca, codigo_empresa, url_ws_empresa,captchaToken) => {
    let json = {
        "canal":body_ca.canal, 
        "claveInteres":body_ca.claveInteres,
        "codBarra":body_ca.codBarra,
        "cuentaContrato":body_ca.numCli, 
        "docsList":body_ca.docs,
        "phrase1":body_ca.phrase1,
        "phrase2":body_ca.phrase2,
        "phrase3":body_ca.phrase3,
        "montoCuota":body_ca.montoCuota,
        "montoDeuda":body_ca.montoDeuda,
        "numCuotas":body_ca.numCuotas,
        "piePago":body_ca.piePago,
        "sociedad":codigo_empresa, 
        "tasaInteres":body_ca.tasaInteres,
        "url":url_ws_empresa, // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
    };


    let jsonDoc = {};
    const formData  = new FormData();
    
    if(body_ca.showDocuments) {
        
        jsonDoc = {
            "identidad": body_ca.identidad && body_ca.identidad.length > 0?body_ca.identidad[0]:null,
            "poderNotarial": body_ca.poderNotarial && body_ca.poderNotarial.length > 0?body_ca.poderNotarial[0]:null, 
            "dominioVigente": body_ca.dominioVigente && body_ca.dominioVigente.length > 0?body_ca.dominioVigente[0]:null, 
        }
    } else {

        jsonDoc = {
            "identidad": null,
            "poderNotarial": null, 
            "dominioVigente": null, 
        }
    }
    
    for (let i in jsonDoc) {
        if (jsonDoc.hasOwnProperty(i)) {
           formData.append([i], jsonDoc[i]);
        }
    }
    
    const response = await LiferayFetchAPI.postDoc(`${base_url_api}crearConvenio`, {accessToken, captchaToken, body:json , auxFormData: formData });
    return response || [];
}

const consultarDetalleCuentaContrato = async (base_url_api, id_client, url_ws_empresa, codigo_empresa, captchaToken) => {
    let json = {
        "ITEM": {
            "Sociedad": codigo_empresa,
            "cta_cto": id_client
        },
        "url": url_ws_empresa,
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}detalleCuentaContrato`, { accessToken, captchaToken , body: json });
    return response?.data || [];
}

const consultarEstadoSolicitudED = async (base_url_api, id_client, rutPatient, captchaToken) => {
    let json = {
        "rutPatient": rutPatient,
        "nroCliente": id_client
      };
    const response = await LiferayFetchAPI.post(`${base_url_api}getEstadoSolicitudED`, { accessToken,captchaToken, body: json });
    return response?.data || [];
}

const consultarDetalleCuentaContratoSL = async (base_url_api, id_client, url_ws_empresa, codigo_empresa, captchaToken) => {
    let json = {
        "ITEM": {
            "Sociedad": codigo_empresa,
            "cta_cto": id_client
        },
        "url": url_ws_empresa,
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}detalleCuentaContratoSL`, { accessToken, captchaToken , body: json });
    return response?.data || [];
}

const consultPvc = async (base_url_api, id_client, codigo_empresa, captchaToken) => {
    let json = {
        "cuentaContrato": id_client,
        "empresa": codigo_empresa
      };
    const response = await LiferayFetchAPI.post(`${base_url_api}consultaPVC`, { accessToken,captchaToken, body: json });
    return response?.data || [];
}

const getListTipoInteracciones = async (base_url_api, tipoInteraccion, empresa) => {
    let json = {
        "activo": true,
        "tipo": tipoInteraccion,
        "empresa": empresa
      };
    const response = await LiferayFetchAPI.post(`${base_url_api}getTipoInteracciones`, { accessToken, body: json });
    return response?.data || [];
}

const getPrecioMaterial = async (base_url_api, codigo_empresa, codigoInteraccion) => {
    let json = {
        "codInteraccion": codigoInteraccion,
        "empresa": codigo_empresa
      };
    const response = await LiferayFetchAPI.post(`${base_url_api}getPrecioMaterial`, { accessToken, body: json });
    return response?.data || [];
}

const getListLastTickets = async (base_url_api, idCtaCto, qtd_tickets, codigo_empresa, url_ws_empresa) => {
    let json = {
        "CuentaContrato": idCtaCto,
        "CantidadDocumentos": qtd_tickets,
        "RangoFechas": "",
        "Sociedad": codigo_empresa,
        "url": url_ws_empresa
    }
    const response = await LiferayFetchAPI.post(`${base_url_api}consultarListaUltimasBoletas`, { accessToken, body: json });
    return response?.data || [];
}

const getDetailTicketPDF = async (base_url_api, id_cta_cto, url_ws_empresa, codigo_empresa, nDoc, signedIn, title, fechaEmision) => {
    let json = {
      "Documentos": {
        "OPBEL": nDoc
      },
      "Sociedad":  codigo_empresa,
      "cuentaContrato": id_cta_cto,
      "signedIn": signedIn,
      "url": url_ws_empresa,
      "title": title,
      "fechaEmision": fechaEmision
    }
    const response = await LiferayFetchAPI.postPDF(`${base_url_api}consultarDetalleBoletaPDF`, { accessToken, body: json });
    return response;
}

const getStateRequest = async (base_url_api, serv1, sociedad, url_ws_empresa,captchaToken) => {
    let json = {
        "NUMERO_AVISO": serv1.numApp,
        "SOCIEDAD": sociedad,
        "isSignedIn": serv1.isSignedIn,
        "url": url_ws_empresa
    };
    
    const response = await LiferayFetchAPI.post(`${base_url_api}consultaEstadoSolicitud`, { accessToken,captchaToken, body: json });
    return response?.data || [];
}

const getCard = async (base_url_api, numApp, url_ws_empresa,codigo_empresa,isSms,captchaToken) => {

    let json = {
        "NUMERO_AVISO": numApp,
        "url": url_ws_empresa,
        "empresa": codigo_empresa,
        "isSMS" : isSms
    };

    let objSend = {};
    if(captchaToken) {
        objSend = { accessToken , captchaToken , body: json, shouldSendFilename: true };
    } else {
        objSend = { accessToken , body: json, shouldSendFilename: true };
    }
    
    const response = await LiferayFetchAPI.postPDF(`${base_url_api}consultarCartaRespuesta`, objSend);
    return response || [];
}

const getStateClaim = async (base_url_api, serv1, sociedad, url_ws_empresa) => {

    if(Number(serv1.valueRadio) === 0) {
        let json = {
            "NUMERO_AVISO": serv1.numClaim,
            "SOCIEDAD": sociedad,
            "isSignedIn": serv1.isSignedIn,
            "url": url_ws_empresa
        };
        
        const response = await LiferayFetchAPI.post(`${base_url_api}consultaReclamoComercial`, { accessToken, body: json });
        return response?.data || [];
        
    } else {
        let json = {
            "NumeroTicket": serv1.numClaim,
            "SOCIEDAD": sociedad,
            "isSignedIn": serv1.isSignedIn,
            "url": url_ws_empresa
        };
        
        const response = await LiferayFetchAPI.post(`${base_url_api}consultaReclamoInterrupcionServicio`, { accessToken, body: json });
        return response?.data || [];
    }
}

const getCardClaim = async (base_url_api, serv2, url_ws_empresa,codigo_empresa) => {
    let json = {
        "NUMERO_AVISO": serv2.numClaim,
        "url": url_ws_empresa,
        "empresa": codigo_empresa,
        "isSMS": false
    };
    
    const response = await LiferayFetchAPI.postPDF(`${base_url_api}consultarCartaRespuesta`, { accessToken, body: json, shouldSendFilename: true });
    return response || [];
}

const verificarPagoCertificado = async (base_url_api, sociedad, typeCertificate) => {
    let json = {
        "activo": true,
        "contentName": "Cobro de Certificados",
        "empresa": sociedad,
        // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
        "tipoInteraccion": typeCertificate
      };
    
    const response = await LiferayFetchAPI.post(`${base_url_api}verificarPagoCertificado`, { accessToken, body: json });
    return response?.data || [];
}


const emisionCertificado = async (base_url_api, idClient, sociedad, url_ws_empresa, typeCertificate, canal, email, webContentCorreoTitle, signedIn) => {
    let json = {
            "Canal": canal,
            "Correo": email,
            "CuentaContrato": idClient,
            "Sociedad": sociedad,
            "TipoCertificado": typeCertificate,
            "isCertificadoDeuda": typeCertificate === "DE" ? true : false,
            "signedIn": signedIn,
            "url": url_ws_empresa,
            "webContentCorreo": webContentCorreoTitle,
            // eslint-disable-next-line no-undef
            "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
        
    };
    
    const response = await LiferayFetchAPI.postPDF(`${base_url_api}emisionCertificado`, { accessToken, body: json });
    return response || [];
}

const editContactClient = async (base_url_api, form, url_ws_empresa) => {

    let json = {
        "email": form.email,
        "empresa": url_ws_empresa,
        "infoInterrupcion": true,
        "mayorEdad": true,
        "nombreCompleto": form.nombreCompleto,
        "notifPromocion": form.notifPromocion,
        "notifServicio": form.notifServicio,
        "notifSuministro": form.notifSuministro,
        "nroCliente": form.nroCliente,
        "rutUsuario": form.rutUsuario,
        "telefono": form.telefono
      };

    const response = await LiferayFetchAPI.post(`${base_url_api}datoscontatousuario`, { accessToken, body: json });
    return response?.data || [];
}

const altaSuscripcion = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}alta-suscripcion`, { accessToken, body: json });
    return response?.data || [];
}

const confirmationAltaSuscripcion = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}confirmacion-alta-suscripcion`, { accessToken, body: json });
    return response?.data || [];
}

const anulationSubscription = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}anula-suscripcion`, { accessToken, body: json });
    return response?.data || [];
}

const verificateModificationSubscription = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}verificar-modificacion-suscripcion`, { accessToken, body: json });
    return response?.data || [];
}

const modificationSubscription = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}modificacion-suscripcion`, { accessToken, body: json });
    return response?.data || [];
}

const confirmModificationSubscription = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}confirmar-modificacion-suscripcion`, { accessToken, body: json });
    return response?.data || [];
}

const getAllRegions = async (base_url_api) => {

    const response = await LiferayFetchAPI.get(`${base_url_api}all-regions`);
    return response?.data || [];
}

const getComunasFromRegion = async (base_url_api, idRegion) => {

    const response = await LiferayFetchAPI.get(`${base_url_api}comunas-from-region/?regionId=${idRegion}`,{accessToken});
    return response?.data || [];
}

const allTipoTlectrodependientes = async (base_url_api) => {

    const response = await LiferayFetchAPI.get(`${base_url_api}all-tipoelectrodependientes`,{accessToken});
    return response?.data || [];
}

const electrodependiente = async (base_url_api, json, jsonDoc) => {
    const formData  = new FormData();

    for (let i in jsonDoc) {
        if (jsonDoc.hasOwnProperty(i)) {
           formData.append([i], jsonDoc[i][0]);
        }
    }
    
    const response = await LiferayFetchAPI.postDocJson(`${base_url_api}electrodependiente`, {accessToken, body:json , auxFormData: formData });
    return response || [];
}

const electrodependienteRenovacion = async (base_url_api, json, jsonDoc) => {
    const formData  = new FormData();

    for (let i in jsonDoc) {
        if (jsonDoc.hasOwnProperty(i)) {
           formData.append([i], jsonDoc[i][0]);
        }
    }
    
    const response = await LiferayFetchAPI.postDocJson(`${base_url_api}electrodependienteRenovacion`, {accessToken, body:json , auxFormData: formData });
    return response || [];
}

const electrodependienteBaja = async (base_url_api, json, jsonDoc) => {
    const formData  = new FormData();

    for (let i in jsonDoc) {
        if (jsonDoc.hasOwnProperty(i)) {
           formData.append([i], jsonDoc[i][0]);
        }
    }
    
    const response = await LiferayFetchAPI.postDocJson(`${base_url_api}electrodependienteBaja`, {accessToken, body:json , auxFormData: formData });
    return response || [];
}

const electrodependienteCambioDomicilio = async (base_url_api, json, jsonDoc) => {
    const formData  = new FormData();

    for (let i in jsonDoc) {
        if (jsonDoc.hasOwnProperty(i)) {
           formData.append([i], jsonDoc[i][0]);
        }
    }
    
    const response = await LiferayFetchAPI.postDocJson(`${base_url_api}electrodependienteCambioDomicilio`, {accessToken, body:json , auxFormData: formData });
    return response || [];
}

const consultarDetalleInstalacionPorCuentaContrato = async (base_url_api, id_client, url_ws_empresa, codigo_empresa) => {
    let json = {
        "ITEM": {
            "Sociedad": codigo_empresa,
            "cta_cto": id_client
        },
        "url": url_ws_empresa,
    };
    const response = await LiferayFetchAPI.post(`${base_url_api}consultarDetalleInstalacionPorCuentaContrato`, { accessToken, body: json });
    return response?.data || [];
}

const getMechanisms = async (base_url_api) => {
    const response = await LiferayFetchAPI.post(`${base_url_api}tiposIntalacionesRe`, { accessToken, body: {} });
    return response?.data || [];
}
const setFormRe = async (base_url_api,arData,url_ws_empresa, codigo_empresa,signedIn) => {
    let json = {
        "apellidoWS": arData[1]?.apellido,
        "apellidoMaterno": arData[0]?.nameMother,
        "apellidoPaterno": arData[0]?.nameFather,
        "calle": arData[0]?.calle,
        "comuna": arData[0]?.comuna,
        "cuentaContrato": arData[0]?.numberClient,
        "descripcionEquipos": arData[0]?.desc_1,
        "dirDpto": arData[0]?.dpto,
        "empresa": codigo_empresa,
        "fullAdress": arData[1]?.fullAdress,
        "idMecanismoMedicion": arData[0]?.selectOptions,
        "mail": arData[0]?.email, 
        "nombres": arData[0]?.name,
        "numero": arData[0]?.number, 
        "potencia": arData[0]?.desc_2,
        "primerNombreWS": arData[1]?.primerNombre,
        "rut": arData[0]?.rut, 
        "segundoNombreWS": arData[1]?.segundoNombre,
        "signedIn": signedIn,
        "telefono": arData[0]?.cel,
        "url": url_ws_empresa
        }; 
    const response = await LiferayFetchAPI.post(`${base_url_api}ingresoFormularioReconversion`, { accessToken, body: json });
    return response?.data || [];

}
const getPagoInfo = async (base_url_api,  body_dcc, sociedad, url_ws_empresa) => {

    let json = {
            "I_CANAL": body_dcc[0],
            "I_VKONT": body_dcc[1],
            "Sociedad": sociedad,
            "url": url_ws_empresa
        };

    const response = await LiferayFetchAPI.post(`${base_url_api}getPagoInfo`, { accessToken, body: json });
    return response?.data || [];
} 

const startPago = async (base_url_api, body_str, sociedad, signedIn) => {

    let json = {
            "cuentaContrato": body_str[0],
            "monto": body_str[1],
            "sociedad": sociedad,
            "signedIn": signedIn
        };

    const response = await LiferayFetchAPI.post(`${base_url_api}startPago`, { accessToken, body: json });
    return response?.data || [];
}


const createFintocCheckoutSession = async (base_url_api, endpoint, json) => {
    const normalizedEndpoint = endpoint || "fintoc/create-session";
    const url = `${base_url_api}${normalizedEndpoint.startsWith("/") ? normalizedEndpoint.substring(1) : normalizedEndpoint}`;
    const response = await LiferayFetchAPI.post(url, { accessToken, body: json });
    return response?.data || [];
}

const getFintocPaymentStatus = async (base_url_api, endpoint, internalTransactionId) => {
    const normalizedEndpoint = endpoint || "fintoc/payment-status";
    const cleanEndpoint = normalizedEndpoint.startsWith("/") ? normalizedEndpoint.substring(1) : normalizedEndpoint;
    const separator = cleanEndpoint.includes("?") ? "&" : "?";
    const url = `${base_url_api}${cleanEndpoint}${separator}transaction=${encodeURIComponent(internalTransactionId)}`;
    const response = await LiferayFetchAPI.get(url, { accessToken });
    return response?.data || [];
}

const proofPayment = async (base_url_api, id,signedIn) => {
    
    let json = {
        "signedIn": signedIn
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}comprobante?paymentIDParam=${id}`, { accessToken, body: json});
    return response?.data || [];
}

const sendEmaillComprobante = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}mailComprobante`, { accessToken, body: json });
    return response?.data || [];
}

const getHtmlComprobante = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}showComprobante`, { accessToken, body: json });
    return response?.data || [];
}


const validCtactoReg = async (base_url_api,ctaCto,url_ws_empresa,content_name) => {
    let json = {
        "contentName": content_name,
        "numeroCtaContrato": ctaCto,
        // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
        "url": url_ws_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}validar-cuenta-contrato-lectura`, { accessToken, body: json });
    return response?.data || [];
}

const sendFormConvVulne = async (base_url_api,dataForm,url_ws_empresa,codigo_empresa,signedIn) => {
    let jsonDoc = {
        "nroCliente": dataForm[0]?.nroCliente,
        "nombres": dataForm[0]?.nombrePaciente,
        "apellidoPaterno": dataForm[0]?.apelidoPaterno,
        "apellidoMaterno": dataForm[0]?.apelidoMaterno,
        "rut": dataForm[0]?.inputRut,
        "phone": dataForm[0]?.fono,
        "mail": dataForm[0]?.email,
        "comuna": dataForm[0]?.detailClientJson.COMUNA,
        "calle": dataForm[0]?.detailClientJson.CALLE,
        "numero": dataForm[0]?.detailClientJson.NUMERO_CASA,
        "dirDpto": dataForm[0]?.detailClientJson.EDIFICIO?dataForm[0]?.detailClientJson.EDIFICIO:"",
        "fullAdress": dataForm[0]?.detailClientJson.COMUNA+" "+dataForm[0]?.detailClientJson.CALLE+" "+dataForm[0]?.detailClientJson.NUMERO_CASA,
        "primerNombreWS": dataForm[0]?.detailClientJson.PRIMER_NOMBRE_PERSONA,
        "segundoNombreWS": dataForm[0]?.detailClientJson.SEGUNDO_NOMBRE_PERSONA,
        "apellidoWS": dataForm[0]?.detailClientJson.APELLIDO_PERSONA,
        "instalacionWS": dataForm[0]?.detailClientJson.INSTALACION,
        "numeroCuotas": Number(dataForm[0]?.qtdCuetas),
        "cobroProximaFacturacion": Number(dataForm[0]?.nextBilling),
        "incluyeDeuda": Number(dataForm[0]?.includeDebt),
        "suscripcionBoleta": dataForm[0]?.valueCheckBoxTicketSubscription?1:0,
        "idTipoInteraccion": dataForm[0]?.typeVunerab,
        "empresa": codigo_empresa,
        "signedIn": signedIn,
        "contentName": dataForm[0]?.contentName,
        // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
        "url": url_ws_empresa
      };

    const formData  = new FormData();

    for (let i in dataForm[0]?.files) {
        if (dataForm[0]?.files.hasOwnProperty(i)) {
            formData.append([i], dataForm[0]?.files[i][0]);
        }
    }

    const response = await LiferayFetchAPI.postDocJson(`${base_url_api}registroFormularioCovid19`, {accessToken, body:jsonDoc , auxFormData: formData });
    return response || [];
}

const sendDataForm = async (base_url_api,dataForm,url_ws_empresa,codigo_empresa,signedIn) => {

    let json = {
        "cantidadDigitosMedidor": Number(dataForm.qtdDigMed),
        "comuna": dataForm.comuna,
        "direccion": dataForm.deliAddress,
        "emailCliente": dataForm.values.Email,
        "empresa": codigo_empresa,
        "fechaLectura": dataForm.readingDate,
        "nombreCliente": dataForm.values.FullName,
        "nroCliente": dataForm.values.CuentaContrato,
        "observacion": dataForm.values.Observacion,
        "signedIn": signedIn,
        "suscripcionBoleta": dataForm.values.ConfirmacionCheckbox,
        "tipoTarifa": dataForm.fareType,
        "url": url_ws_empresa,
        "valorMedidor": dataForm.values.MeterReading
        }
    const response = await LiferayFetchAPI.post(`${base_url_api}formularioIngresoLectura    `, { accessToken, body: json });
    return response?.data || [];
}

const sendFormGroupCollective = async (base_url_api,dataForm,url_ws_empresa,codigo_empresa,signedIn,contentName) => {

    let json = {
        "nroCliente":dataForm.form.numberClient,
        "nombres":dataForm.form.name,
        "apellidoPaterno":dataForm.form.nameFather,
        "apellidoMaterno":dataForm.form.nameMother,
        "rut":dataForm.form.rut, 
        "phone":dataForm.form.tel,
        "mail":dataForm.form.email,
        "idTipoInteraccion":Number(dataForm.form.typeVulnerability),
        "countFamilias":Number(dataForm.form.qtdFamily),
        "udConvenioDoc doc":"", 
        "primerNombreWS":dataForm.detailClient.PRIMER_NOMBRE_PERSONA,
        "segundoNombreWS":dataForm.detailClient.SEGUNDO_NOMBRE_PERSONA,
        "apellidoWS":dataForm.detailClient.APELLIDO_PERSONA,
        "instalacionWS":dataForm.detailClient.INSTALACION,
        "comuna":dataForm.form.comuna,
        "calle":dataForm.form.calle,
        "numero":dataForm.form.number,
        "dirDpto": dataForm.form.dpto.replaceAll("null",""),
        "empresa":codigo_empresa,
        "url":url_ws_empresa,
        "signedIn":signedIn,
        "contentName":contentName,
        // eslint-disable-next-line no-undef
        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`
    }

    let jsonDoc = {};
    const formData  = new FormData();

    jsonDoc = {
        "file": dataForm.file.certif && dataForm.file.certif.length > 0?dataForm.file.certif[0]:null
    }
    
    for (let i in jsonDoc) {
        if (jsonDoc.hasOwnProperty(i)) {
        formData.append([i], jsonDoc[i]);
        }
    }

    const response = await LiferayFetchAPI.postDocJson(`${base_url_api}formularioConvenioAgrupacionesColectivas`, {accessToken, body:json , auxFormData: formData });
    return response || [];
}


const consultSubsidy = async (base_url_api,ctaCto,url_ws_empresa,codigo_empresa,captchaToken) => {
    let json = {
        "CuentaContrato": ctaCto,
        "url": url_ws_empresa,
        "empresa": codigo_empresa
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}consultaSubsidio`, { accessToken,captchaToken, body: json });
    return response?.data || [];
}

const checkModificationFormCovid = async (base_url_api, data) => {
    let json = {
        "cta_cto": data.cta_cto,
        "rut": data.rut
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}checkModificacionFormCovid`, { accessToken, body: json });
    return response?.data || [];
}

const modifyCovidFormData = async (base_url_api, data) => {
    let json = {
        "cta_cto": data.cta_cto,
        "nroCuotas": data.nroCuotas,
        "rut": data.rut
    };
    
    const response = await LiferayFetchAPI.post(`${base_url_api}modificarFormCovid`, { accessToken, body: json });
    return response?.data || [];
}

const calculateFeeCovidForm = async (base_url_api, data) => {
    let json = {
        "canal": data.canal,
        "cuentaContrato": data.cuentaContrato,
        "empresa": data.empresa,
        "url": data.url,
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}calcularCuotaFormCovid`, { accessToken, body: json });
    return response?.data || [];
}

const setActionReports = async (base_url_api, data) => {
    let json = {
        "ano": data.ano,
        "mes": data.mes,
        "tipo": data.tipo,
        "accion": Number(data.idAccion),
        "pageSize": "1",
        "page": "1"
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}reportes-acciones`, { accessToken, body: json });
    return response?.data || [];
}


const getAccionesDetalle = async (base_url_api, json) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}reportes-detalle-acciones`, {accessToken, body: json });
    return response?.data || [];
}

const getUnconfirmedSubscription = async (base_url_api, data) => {
    let json = {
        "mes": data.month,
        "ano": data.year
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}suscripcion-sin-confirmar`, {accessToken, body: json });
    return response?.data || [];
}

const getOficinaVirtual = async (base_url_api) => {
    const response = await LiferayFetchAPI.get(`${base_url_api}reportes-oficina-virtual`,{accessToken});
    return response?.data || [];
}

const awsToken = async (base_url_api, json) => {
    const response = await LiferayFetchAPI.post(`${base_url_api}awsToken`, { accessToken,body: json});
    return response?.data || [];
}

const getUserAttributes = async (base_url_api) => {
    const response = await LiferayFetchAPI.post(`${base_url_api}aws-user-attributes`, { accessToken });
    return response?.data || [];
}

const postUserAttributes = async (base_url_api, json) => {
    const response = await LiferayFetchAPI.post(`${base_url_api}updateUser`, { accessToken, body: json });
    return response || [];
}

const getActionsList = async (base_url_api) => {
    const response = await LiferayFetchAPI.get(`${base_url_api}acciones`);
    return response?.data || [];
}

const setDesactiveAccount = async (base_url_api, screenName) => {

    const json = {
        "userName": screenName,
    };

    const response = await LiferayFetchAPI.post(`${base_url_api}aws-user-disable`, { accessToken, body: json });
    return response?.data || [];
}
const setNewPassword = async (base_url_api,formData) => {

    let json = {
        "previousPassword": formData?.old,
        "proposedPassword": formData?.new
    }

    const response = await LiferayFetchAPI.post(`${base_url_api}change-password`,  {accessToken, body: json });
    return response || [];
}

const createNewUser = async (base_url_api,form,codigo_empresa, captchaToken) => {

    let json = {
        "Password": form?.password,
        "Username": form?.rut.replaceAll(".",""),
        "cognitoRegisterRequestRootUserAttributesDTO": {
            "custom:address_commune": form?.comuna,
            "custom:address_region": form?.region,
            "custom:address_number": form?.addressNumber,
            "custom:address_building": form?.addressApt,
            "custom:address_street": form?.address,
            "custom:house_phone_number": (form?.prefixCell ? form?.prefixCell : 2)+form?.tel,
            "custom:second_family_name": form?.secondName,
            "email": form?.email,
            "family_name": form?.firstName,
            "given_name": form?.name,
            "phone_number": form?.cel?"+56"+form?.cel:""
        },
        "empresa": codigo_empresa,
        "numeroCliente": form?.numberClient,
        "nombreCuenta": form?.nameAccount,
        "relacionCuenta": form?.relation
    }
    
    
    const response = await LiferayFetchAPI.post(`${base_url_api}signUp`, {accessToken, captchaToken, body: json });

    return response || [];
}



const sendFormAddNumberAccount = async (base_url_api,form) => {

    let json = {
        "CrearAccountRequest": {
            "Alias": form.nameAccount,
            "CtaCto": form.numberClient,
            "Relation": form.relation
        },
        "SubscriptionEmail": form.valueCheckBoxSubscription ? true : false
      }

    const response = await LiferayFetchAPI.post(`${base_url_api}accounts`, {accessToken, body: json });

    return response || [];
}

const getRelationctacto = async (base_url_api) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}getRelationctacto`, {accessToken, body: {} });

    return response?.data || [];
}

const awsForgotPassword = async (base_url_api,rut) => {

    let json = { 
        "username": rut,
        // eslint-disable-next-line no-undef
        "companyId": Liferay.ThemeDisplay.getCompanyId()
    } 

    const response = await LiferayFetchAPI.post(`${base_url_api}aws-forgot-password`, {accessToken, body: json });

    return response || [];
}

const awsConfirmForgotPassword = async (base_url_api,data) => {

    let json = { 
        // eslint-disable-next-line no-undef
        "companyId": Liferay.ThemeDisplay.getCompanyId(),
        "confirmationCode": data.code,
        "password": data.password,
        "username": data.rut
    } 

    const response = await LiferayFetchAPI.post(`${base_url_api}aws-confirm-forgot-password`, {accessToken, body: json });
    return response || [];
}

const postAccount = async (base_url_api,form) => {

    let json = {
        "Alias": form?.name,
        "CtaCto": form?.id
    }

    const response = await LiferayFetchAPI.put(`${base_url_api}accounts`, {accessToken, body: json });
    return response || [];
}

const deleteAccount = async (base_url_api,id) => {

    if(Array.isArray(id)) {

        let json = {
            "accounts": id
          }
    
        const response = await LiferayFetchAPI.delete(`${base_url_api}delete-accounts`, {accessToken, body: json });
        return response || [];
    } else {
        const response = await LiferayFetchAPI.delete(`${base_url_api}accounts?ctaCto=${id}`, {accessToken, body: {} });
        return response || [];
    }
}

const listSuscripciones = async (base_url_api) => {

    const response = await LiferayFetchAPI.post(`${base_url_api}list-suscripciones`, {accessToken, body: {} });
    return response || [];
}

const checkIfCanRegisterNewUserWithRutAndAccount = async (base_url_api, rut, numberClient) => {
    // eslint-disable-next-line no-undef
    const response = await LiferayFetchAPI.get(`${base_url_api}checkIfCanRegisterNewUserWithRutAndAccount?companyId=${Liferay.ThemeDisplay.getCompanyId()}&username=${rut}&account=${numberClient}`, {accessToken });
    return response || [];
}

const getAllDatos = async (base_url_api) => {
    const response = await LiferayFetchAPI.get(`${base_url_api}all-datoscontatousuarios`);
    return response || [];
}

const getAllSolicitudesRES = async (base_url_api) => {
    const response = await LiferayFetchAPI.get(`${base_url_api}all-solicitudesRES`);
    return response || [];
}

export const LiferayService = {
    REACT_APP_LIFERAY_API,
    getPagos,
    getEstaSinLuz,
    getTipoPresentacion,
    postFormCont,
    getIdList,
    getSaldoCross,
    getDebtCc,
    getCouponCc,
    getWebContent,
    getCurrentBalance,
    getListaClientesAssociados,
    getCurrentEstadoServicio,
    getCompensation,
    getNetbilling,
    getHistoryConsu,
    getResponseDoc,
    getListaCartolaReliquidation,
    getReliquidation,
    getComuna,
    getCalles,
    getClienteDireccion,
    getClienteMedidor,
    createTicketReclamo,
    consultarEstadoServicio,
    consultarDetalleCuentaContrato,
    consultarDetalleCuentaContratoSL,
    consultarEstadoSolicitudED,
    getListTipoInteracciones,
    getAllComunas,
    getValidClient,
    getSimulacionAgreement,
    validarConvenioPagoEspecial,
    simularConvenioPagoEspecial,
    crearConvenioPagoEspecialNotification,
    consultarPuntosSuministro,
    consultarVariablesPuntoSuministro,
    registrarAmiExportExcelLog,
    createAgreement,
    getListLastTickets,
    getPrecioMaterial,
    getDetailTicketPDF,
    createTicketReclamoComercialOrSolicitud,
    getStateRequest,
    getCard,
    getStateClaim,
    getCardClaim,
    emisionCertificado,
    verificarPagoCertificado,
    editContactClient,
    altaSuscripcion,
    confirmationAltaSuscripcion,
    anulationSubscription,
    verificateModificationSubscription,
    modificationSubscription,
    confirmModificationSubscription,
    getAllRegions,
    getComunasFromRegion,
    allTipoTlectrodependientes,
    electrodependiente,
    electrodependienteRenovacion,
    electrodependienteBaja,
    electrodependienteCambioDomicilio,
    consultarDetalleInstalacionPorCuentaContrato,
    getMechanisms,
    setFormRe,
    getPagoInfo,
    proofPayment,
    validCtactoReg,
    sendDataForm,
    consultPvc,
    sendFormGroupCollective,
    sendFormConvVulne,
    consultSubsidy,
    checkModificationFormCovid,
    modifyCovidFormData,
    calculateFeeCovidForm,
    startPago,
    createFintocCheckoutSession,
    getFintocPaymentStatus,
    sendEmaillComprobante,
    getHtmlComprobante,
    setActionReports,
    getAccionesDetalle,
    getUnconfirmedSubscription,
    getOficinaVirtual,
    getUserAttributes,
    postUserAttributes,
    awsToken,
    getActionsList,
    setDesactiveAccount,
    setNewPassword,
    createNewUser,
    sendFormAddNumberAccount,
    getRelationctacto,
    awsForgotPassword,
    awsConfirmForgotPassword,
    postAccount,
    deleteAccount,
    listSuscripciones,
    checkIfCanRegisterNewUserWithRutAndAccount,
    getAllDatos,
    getAllSolicitudesRES
};
